import { useState } from "react";
import ColorApp from "../../components/color/color";
import ModalOtherDetail from "./modal/modalOtherDetail";

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function KpiOther({ dataKpi }) {
  const [modalDetailOther, setModalDetailOther] = useState({ show: false, data: null });
  const getCell = (actual, target) => {
    // kosong
    if (target === 0 && actual === 0) {
      return { text: "", style: null };
    }

    const text = `${actual}/${target}`;
    let background = null;
    let color = "black";

    if (target === 0) {
      // target 0 tapi actual ada
      background = ColorApp().themeColor;
    } else if (actual === 0) {
      // actual 0, target > 0 → merah
      background = "#ff0000";
      color = "white";
    } else if (actual < target) {
      // actual > 0 tapi < target → orange
      background = "orange";
    } else {
      // actual >= target → hijau / theme
      background = ColorApp().themeColor;
    }

    return {
      text,
      style: background ? { background, color, cursor: "pointer" } : null,
    };
  };

  const handleClickGetOtherMontByItem = (data) => {
    setModalDetailOther({ show: true, data });
  };

  const formatCell = (actual, target) => {
    const cell = getCell(actual, target);
    return <td style={cell.style}>{cell.text}</td>;
  };
  return (
    <>
      <div className="table-responsive">
        <table className="table table-bordered table table-hover text-center align-middle">
          <thead className="table-light">
            <tr>
              <th>Num.</th>
              <th style={{ minWidth: 300 }}>ITEM</th>
              {months.map((m) => (
                <th key={m}>{m}</th>
              ))}
              <th>Ytd</th>
            </tr>
          </thead>
          <tbody>
            {dataKpi.other.map((row, i) => (
              <tr key={i}>
                <td className="fw-semibold align-middle">{i + 1}</td>
                <td className="text-start fw-semibold">{row.item}</td>
                {row.value.map((m, idx) => {
                  const cell = getCell(m.actual, m.target);

                  return (
                    <td key={idx} onClick={() => handleClickGetOtherMontByItem({ kpiId: row.id, year: dataKpi.year, month: m.month })} style={cell.style}>
                      {cell.text}
                    </td>
                  );
                })}
                {formatCell(row.yearly.actual, row.yearly.target)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ModalOtherDetail show={modalDetailOther.show} onClose={() => setModalDetailOther((a) => ({ ...a, show: false }))} data={modalDetailOther.data} />
    </>
  );
}

export default KpiOther;
